import { createReducer, on } from '@ngrx/store';
import * as OnboardingActions from './advisor-onboarding.actions';
import { IOnboardingState, initialOnboardingState } from './advisor-onboarding.state';

export const onboardingReducer = createReducer(
  initialOnboardingState,

  on(OnboardingActions.loadOnboardings, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(OnboardingActions.loadOnboardingsSuccess, (state, { onboardings, totalCount, currentPage }) => ({
    ...state,
    isLoading: false,
    onboardings: onboardings || [],
    totalCount: totalCount || 0,
    currentPage: currentPage || 1,
    error: null,
  })),

  on(OnboardingActions.loadOnboardingsFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),

  on(OnboardingActions.setFilter, (state, { filter }) => {
    const page = filter.Page ?? 1;
    return {
      ...state,
      filters: { ...state.filters, ...filter, Page: page },
      currentPage: page,
    };
  }),

  on(OnboardingActions.resetFilter, (state) => ({
    ...state,
    filters: { ...initialOnboardingState.filters },
    currentPage: 1,
  })),

  on(OnboardingActions.updatePagination, (state, { page, pageSize }) => ({
    ...state,
    currentPage: page,
    filters: { ...state.filters, Page: page, PageSize: pageSize },
  })),

  on(OnboardingActions.clearOnboardings, (state) => ({
    ...state,
    onboardings: [],
    totalCount: 0,
    currentPage: 1,
  })),
);
